import React from "react";
import dataSocial from "../../data/Social/social-footer.json";
import { FaInstagram, FaLinkedinIn, FaXTwitter, FaFacebook } from "react-icons/fa6";

const iconMap = {
  FaInstagram: FaInstagram,
  FaLinkedinIn: FaLinkedinIn,
  FaXTwitter: FaXTwitter,
  FaFacebook: FaFacebook,
 

};

// import Icofont from "react-icofont";

const FooterCopyright = () => (
  <div className="footer-copyright">
    <div className="container">
      <div className="row">
        <div className="col-md-6 col-xs-12">
          <ul className="social-media">
            {dataSocial.slice(0, 5).map((item) => {
              const IconComponent = iconMap[item.icon] || null;
              return (
                <li key={item.id}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {IconComponent && <IconComponent />}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="col-md-6 col-xs-12">
          <div className="copy-right text-right">
            © {new Date().getFullYear()} Olshan Realty. All rights reserved
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FooterCopyright;


